import { APIClient, ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';
import { BudgetEntity, BudgetEntityListResponse, BudgetEntityQueryParams, CreateBudgetEntity } from '@frontend/budget/types';

export class BudgetEntityClient extends APIClient {
    public static readonly endpoint = '/budget-api/v1';

    public static async fetchBudgetEntities(queryParams?: ApiQueryParams<DefaultQueryParams & BudgetEntityQueryParams>): Promise<BudgetEntityListResponse> {
        return await this.apiPaginated<BudgetEntityListResponse, DefaultQueryParams & BudgetEntityQueryParams>(`${this.endpoint}/budget-entities`, queryParams);
    }

    public static async resolveBudgetEntities(ids: string[], field: string = 'id'): Promise<BudgetEntityListResponse> {
        return this.resolve<BudgetEntityListResponse>(`${this.endpoint}/budget-entities`, ids, field);
    }

    public static async deleteBudgetEntities(ids: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/budget-entities-delete`, { ids: ids });
        return await this.handleVoidResponse(response);
    }

    public static async postBudgetEntity(accountId: string, budgetId: string, body: CreateBudgetEntity): Promise<BudgetEntity> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/budgets/${budgetId}/entities`, body);
        return await this.handleResponse<BudgetEntity>(response);
    }

    public static async fetchBudgetEntity(accountId: string, budgetId: string, budgetEntityId: string): Promise<BudgetEntity> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/budgets/${budgetId}/entities/${budgetEntityId}`);
        return await this.handleResponse<BudgetEntity>(response);
    }

    public static async deleteBudgetEntity(accountId: string, budgetId: string, budgetEntityId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/budgets/${budgetId}/entities/${budgetEntityId}`);
        return await this.handleVoidResponse(response);
    }
}
